import { createSlice } from '@reduxjs/toolkit';

const getRoute = () => {
  const savedRoute = localStorage.getItem('route');
  return savedRoute ? JSON.parse(savedRoute) : 'missions';
};

const getThemeMode = () => {
  const savedMode = localStorage.getItem('themeMode');
  return savedMode === 'dark' ? 'dark' : 'light';
};

const getDutyActive = () => localStorage.getItem('dutyActive') !== 'false';

const initialState = {
  isLoading: false,
  route: getRoute(),
  themeMode: getThemeMode(),
  dutyActive: getDutyActive(),
  userInfo: null,
  snackBar: '',
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setRoute(state, action) {
      state.route = action.payload;
      localStorage.setItem('route', JSON.stringify(action.payload));
    },
    setThemeMode(state, action) {
      state.themeMode = action.payload === 'dark' ? 'dark' : 'light';
      localStorage.setItem('themeMode', state.themeMode);
    },
    setDutyActive(state, action) {
      state.dutyActive = Boolean(action.payload);
      localStorage.setItem('dutyActive', state.dutyActive ? 'true' : 'false');
    }, 
    setSnackBar(state, action) {
      state.snackBar = action.payload;
    },
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setRoute,
  setThemeMode,
  setDutyActive,
  setSnackBar,
  setUserInfo,
} = globalSlice.actions;
export default globalSlice.reducer;
